<template>
  <div class="shop">
    <h2 class="m-0-16-16-16">{{ $t("subscription.choose") }}</h2>
    <div class="m-16-16-0-16 change_button">
      <el-radio-group v-model="select_type">
        <!-- <el-radio-button label="all">
                    {{ $t('subscription.all') }}
                </el-radio-button> -->
        <el-radio-button label="flow" v-if="show_b1">
          {{ $t("subscription.by_traffic") }}
        </el-radio-button>
        <el-radio-button label="cycle" v-if="show_b2">
          {{ $t("subscription.by_cycle") }}
        </el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="!show" class="m-l-34 m-t-20">
      <div class="watting-dot"></div>
    </div>
    <div v-if="show">
      <div class="row">
        <div
          class="col-md-12 m-top-16 col-xl-4"
          v-for="plan in type_plans"
          :key="plan.pdId"
        >
          <div class="p-0-14">
            <div class="name">
              <span>【{{ plan.pdName }}】</span>
            </div>
            <div class="price">
              <div class="price_content">
                <div class="price_content1">
                  <div v-if="$t('lang') == 'por'">
                    <span class="m-r-20">R${{ plan.packages[0].prices.BRL.real }}</span>
                    <span class="text-delete">R${{ plan.packages[0].prices.BRL.price }}</span>
                  </div>
                  <div v-else>
                    <span class="m-r-20">${{ plan.packages[0].prices.USD.real }}</span>
                    <span class="text-delete">${{ plan.packages[0].prices.USD.price }}</span>
                  </div>
                </div>
                <div class="price_content2">
                  {{ plan.packages[0].pkgType}}
                </div>
              </div>
            </div>
            <div class="content">
              <div  v-html="plan.content"></div>
            </div>
            <div class="plan_but p-l-16 p-t-18">
              <div class="price_content">
                <el-button type="primary" @click="order(plan)">
                  {{ $t("subscription.order") }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { enCodeBase64 } from "../../utils/tool";
import { getAllPackages } from "../../utils/api";
import { ElNotification } from "element-plus";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import {receive_app} from '../../utils/lang_change'
export default {
  setup() {
    const { t,locale } = useI18n();
    const store = useStore();
    let changelanguage = (lang) => {
        locale.value = receive_app(lang)
        sessionStorage.setItem('lang', receive_app(lang))
    }
    return { t, store,changelanguage };
  },
  data() {
    return {
      plans: [],
      type_plans: [], //显示在页面上的
      select_type: "", //all 全部  cycle 周期 flow 流量
      show_b1: false,
      show_b2: false,
      show: false,
    };
  },
  methods: {
    async getShops() {
      await getAllPackages().then((res) => {
        if (res !== undefined) {
          if (res.data.code === 0) {
            //过滤
            this.plans = res.data.data;
            if (this.plans["traffic"].length > 0) {
              this.show_b1 = true;
            }
            if (this.plans["durational"].length > 0) {
              this.show_b2 = true;
            }
            if (this.show_b1 === true) {
              this.select_type = "flow";
            } else {
              this.select_type = "cycle";
            }
            if (Object.keys(this.plans).length !== 0) {
              if (this.select_type === "cycle") {
                this.type_plans = this.plans["durational"];
              } else {
                this.type_plans = this.plans["traffic"];
              }
              this.show = true;
            }
          } else {
            return ElNotification({
              title: this.t("prompt.Mistake"),
              message: res.data.msg,
              type: "error",
            });
          }
        } else {
          return ElNotification({
            title: "Error",
            message: "Network error",
            type: "error",
          });
        }
      });
    },
    order(plan) {
      //要将所有语言的该产品选择出来
      this.$router.push({
        name: "shopConfigure",
        params: { obj: enCodeBase64(JSON.stringify(plan)) },
      });
      this.store.commit(
        "updateActiveName",
        "subscription.configure_subscription"
      );
      this.store.commit("updateActivePath", "/shopConfigure");
    },
  },
  async created() {
    
    let from = this.$route.query.from;
    let lang = this.$route.query.lang;
    if (from === "mobile") {
      //手机端app跳转,去掉头部和侧边
      this.store.commit("updateMobile", true);
      this.changelanguage(lang);
    }
    await this.getShops();
  },
  watch: {
    select_type(newVal) {
      if (newVal === "cycle") {
        this.type_plans = this.plans["durational"];
      } else if (newVal === "flow") {
        this.type_plans = this.plans["traffic"];
      }
    },
    '$i18n.locale'() {
      this.getShops();
    },
  },
};
</script>

<style scoped></style>